module.exports = __webpack_public_path__ + "img/crown.7f2a07da.svg";